import React from 'react';
import { ArrowRightIcon, EyeIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden" data-id="element-77">
      {/* Background effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-900/20 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-78"></div>

      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-79">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-80">
          {/* Left: Text Content */}
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-81">
            <div className="inline-flex items-center justify-center p-2 bg-slate-800/50 border border-slate-700 rounded-full mb-8" data-id="element-82">
              <EyeIcon className="h-5 w-5 text-brand-400 mr-2" data-id="element-83" />
              <span className="text-sm font-medium text-slate-300 uppercase tracking-wider" data-id="element-84">
                Sistema Táctico de Decodificación
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6 tracking-tight" data-id="element-85">
              El Código de las Micro-Señales:{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-400 to-brand-600" data-id="element-86">
                Detecta la Mentira en Segundos
              </span>
            </h1>

            <h2 className="text-lg md:text-xl font-medium text-slate-300 mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-87">
              Aprende el sistema táctico de decodificación facial para leer
              intenciones ocultas, evitar manipulaciones y recuperar el control
              en cualquier conversación.
            </h2>

            <div className="bg-slate-800/40 border-l-4 border-brand-500 p-5 md:p-6 rounded-r-xl mb-8 text-left backdrop-blur-sm" data-id="element-88">
              <p className="text-base md:text-lg text-slate-200 leading-relaxed" data-id="element-89">
                ¿Alguna vez has sentido que alguien te miente, pero no puedes
                demostrarlo? Esa náusea en el estómago no es paranoia. Es tu
                instinto detectando una incongruencia que tus ojos aún no saben
                identificar.
              </p>
              <p className="text-base md:text-lg text-slate-200 leading-relaxed mt-3" data-id="element-90">
                Mientras tú dudas, la otra persona mantiene el control de la
                narrativa. Estás jugando a ciegas en un mundo donde lo que no se
                dice es más importante que lo que se grita.
              </p>
            </div>

            <div data-id="element-91">
              <a href="#comprar" className="inline-flex items-center justify-center bg-brand-600 hover:bg-brand-500 text-white font-bold px-8 py-4 rounded-xl text-lg md:text-xl transition-all duration-300 shadow-[0_0_30px_rgba(13,148,136,0.4)] transform hover:scale-105 active:scale-95 w-full md:w-auto" data-id="element-92">
                Quiero el Código <ArrowRightIcon className="ml-2 h-6 w-6" data-id="element-93" />
              </a>
            </div>
          </div>

          {/* Right: Product Image */}
          <div className="lg:w-1/2 flex justify-center" data-id="element-94">
            <div className="relative max-w-md w-full" data-id="element-95">
              <div className="absolute -inset-4 bg-brand-500/10 rounded-3xl blur-2xl pointer-events-none" data-id="element-96"></div>
              <img src="https://cdn.magicpatterns.com/uploads/6LPjQWAuopxkSqPGhWYyq4/A_high-end_iPad_202604241743.jpg" alt="Código de Micro-Señales - eBook" className="relative rounded-2xl shadow-2xl w-full object-cover border border-slate-700/50" data-id="element-97" />
              <div className="absolute -bottom-3 -right-3 bg-brand-600 text-white px-4 py-2 rounded-lg shadow-lg font-bold text-sm" data-id="element-98">
                Descarga Inmediata
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}